module.exports = __webpack_public_path__ + "img/MABCO.845da8d8.svg";